import React from 'react';
import PropTypes from 'prop-types';
import { createModal } from 'react-modal-promise';

function ConfirmModal({ text, close }) {
  return (
    <div className="p-modal-container">
      <div className="p-modal">
        <i
          onClick={() => close(false)}
          className="modal-close close icon"
          alt="close"
        />
        <div className="p-modal-body">{text}</div>
        <div className="p-modal-actions">
          <button
            type="button"
            className="btn btn-primary btn-large btn-large-default"
            onClick={() => close(true)}
          >
            Confirm
          </button>
          <button
            type="button"
            className="btn btn-default btn-large"
            onClick={() => close(false)}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}

ConfirmModal.propTypes = {
  text: PropTypes.string,
  close: PropTypes.func,
};

export default createModal(ConfirmModal);
